import axios from 'axios'
import { stringIsNullOrEmpty } from './utils/mapHelpers'

const socialURL = process.env.REACT_APP_SOCIAL_URL

export const LOCATION_PARAMS = {
  lat: 36.12799612441369,
  long: -5.392037148437498,
  radius: 10000
}

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export const postApiData = (url, data, callback, errorHandler) =>
  axios({
    method: 'post',
    url,
    data: data ? JSON.stringify(data) : null,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      if (errorHandler) {
        errorHandler(error)
      } else {
        console.log(`Post request failed at url - ${url} - ${error}`)
      }
    })

export const getApiData = url =>
  axios({
    method: 'get',
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.log(`Get request failed at url - ${url} - ${error}`)
      return error
    })

export const deleteApiData = url =>
  axios({
    method: 'delete',
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/javascript'
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.log(`Delete request failed at url - ${url} - ${error}`)
      return error
    })

export const getUserSubscriptionStatus = async () => {
  const url = `${process.env.REACT_APP_SERVER_URL}/subscription-status`

  const res = await axios({
    method: 'get',
    url: url,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getUserProfile = userId => {
  const forOtherUser = !stringIsNullOrEmpty(userId)

  const socialURL = process.env.REACT_APP_SOCIAL_URL
  const url = forOtherUser
    ? `${socialURL}api/UserProfile/getClickedUserProfileById/${userId}`
    : `${socialURL}api/UserProfile/getMyUserProfile/`

  return new Promise((resolve, reject) => {
    getApiData(url)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const dismissCompleteProfilePopup = () => {
  const url = `${socialURL}api/UserProfile/dismissCompleteProfilePopup`

  return axios({
    method: 'put',
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(
        `Error dismissing complete profile popup from server at url - ${url} - ${error}`
      )
    })
}
